import { Routes, Route } from "react-router-dom";
import AdminRouter from "./routes/AdminRouter";
import Router from "./routes/SiteRouter";
import UserRouter from "./routes/UserRouter";
import AdminRouteGuard from "./routes/RouteGuards/AdminRouteGuard";
import UserRouteGuard from "./routes/RouteGuards/UserRouteGuard";
function MusicShare() {
  return (
    <Routes>
      <Route
        path="/admin/*"
        element={<AdminRouteGuard element={<AdminRouter />} />}
      />
      <Route
        path="/user/*"
        element={<UserRouteGuard element={<UserRouter />} />}
      />
      <Route path="/*" element={<Router />} />
    </Routes>
  );
}

export default MusicShare;
